/* =========================================================================
   CHARMANTE — Bandeau de consentement cookies (en bas à gauche)
   Accepter / Refuser / Personnaliser (catégories). Choix mémorisé en
   localStorage (charmante_cookies). À la réponse, émet l'événement
   `cookies:resolved` → la popup newsletter ne s'affiche qu'ensuite.

   ⚠️ DÉMO front-end : ici aucun script tiers n'est réellement déposé. En
   production (Shopify), brancher un vrai outil de consentement (CMP) qui
   bloque/active les scripts analytics & marketing selon ces préférences.
   ========================================================================= */
(function () {
  'use strict';

  const C = (window.Charmante = window.Charmante || {});
  const KEY = 'charmante_cookies';
  const ls = {
    get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  function getPrefs() { try { return JSON.parse(ls.get(KEY)); } catch (e) { return null; } }
  const resolved = () => !!getPrefs();

  function savePrefs(prefs) {
    prefs.necessary = true;                       // toujours actifs
    prefs.ts = new Date().toISOString();
    ls.set(KEY, JSON.stringify(prefs));
    document.dispatchEvent(new CustomEvent('cookies:resolved', { detail: prefs }));
  }

  // API publique (lue notamment par newsletter.js)
  C.cookies = { resolved, get: getPrefs, KEY };
  // « Gestion des cookies » (footer) : rouvre le bandeau à tout moment pour changer son choix.
  C.cookies.reopen = function () { init(); };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cookie-open]');
    if (b) { e.preventDefault(); C.cookies.reopen(); }
  });

  // Le bandeau ne s'affiche AUTOMATIQUEMENT qu'UNE SEULE FOIS : une fois la réponse donnée, le choix
  // est mémorisé et il ne réapparaît plus tout seul (mais reste rouvrable via « Gestion des cookies »). Jamais en back-office.
  if (resolved() || document.getElementById('stockAdmin') || document.getElementById('gcAdmin')) return;

  function init() {
    if (document.querySelector('.cookie-banner')) return;
    const el = document.createElement('aside');
    el.className = 'cookie-banner';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Gestion des cookies');
    el.innerHTML = `
      <p class="cookie-banner__title">🍪 Cookies</p>
      <p class="cookie-banner__text">On utilise des cookies pour faire fonctionner le site et, avec ton accord, mesurer l'audience. Tu choisis. <a href="/pages/politique-de-confidentialite-1#cookies">En savoir plus</a></p>
      <div class="cookie-banner__custom" id="ccCustom" hidden>
        <label class="cookie-opt"><span><strong>Nécessaires</strong><small>Indispensables (panier, connexion, sécurité).</small></span><input type="checkbox" checked disabled aria-label="Cookies nécessaires (toujours actifs)"></label>
        <label class="cookie-opt"><span><strong>Mesure d'audience</strong><small>Statistiques de visite anonymes.</small></span><input type="checkbox" data-cc-cat="analytics"></label>
        <label class="cookie-opt"><span><strong>Marketing</strong><small>Personnalisation &amp; publicités.</small></span><input type="checkbox" data-cc-cat="marketing"></label>
      </div>
      <div class="cookie-banner__actions">
        <button class="btn btn--rose" type="button" data-cc="accept">Tout accepter</button>
        <button class="btn btn--ghost" type="button" data-cc="refuse">Refuser</button>
        <button class="cookie-banner__link" type="button" data-cc="custom" aria-expanded="false" aria-controls="ccCustom">Personnaliser</button>
        <button class="btn btn--rose cookie-banner__save" type="button" data-cc="save" hidden>Enregistrer mes choix</button>
      </div>`;
    document.body.appendChild(el);
    var pr = getPrefs();              // réouverture : refléter le choix déjà fait dans les cases
    if (pr) {
      var ca = el.querySelector('[data-cc-cat="analytics"]'); if (ca) ca.checked = !!pr.analytics;
      var cm = el.querySelector('[data-cc-cat="marketing"]'); if (cm) cm.checked = !!pr.marketing;
    }
    void el.offsetWidth;              // reflow → la transition d'entrée s'anime (sans dépendre de rAF)
    el.classList.add('is-in');

    function decide(prefs) {
      savePrefs(prefs);
      el.classList.remove('is-in');
      setTimeout(() => el.remove(), 350);
    }

    el.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cc]');
      if (!btn) return;
      const action = btn.dataset.cc;
      if (action === 'accept') decide({ analytics: true, marketing: true });
      else if (action === 'refuse') decide({ analytics: false, marketing: false });
      else if (action === 'custom') {
        const custom = el.querySelector('#ccCustom');
        const open = custom.hidden;
        custom.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        el.querySelector('.cookie-banner__save').hidden = !open;
      } else if (action === 'save') {
        decide({
          analytics: !!el.querySelector('[data-cc-cat="analytics"]').checked,
          marketing: !!el.querySelector('[data-cc-cat="marketing"]').checked
        });
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
